import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import Desossa from "../views/Desossa.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/desossador",
    name: "Desossa",
    component: Desossa,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
